// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2gTJp","dragIcon":"SortableItem_dragIcon__2egSD","disabled":"SortableItem_disabled__1D4Pf"};